<template>
  <div>
    <form v-if="supplier" class="form" v-on:submit.prevent="updateSupplier">
      <h1>Supplier: {{ supplier.supplier_name }}</h1>
      <div class="box">
        <Errors/>
        <SupplierFields/>
        <div class="form-wrap form-submit">
          <div class="mt-1" v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled><span>Updating...</span></button>
          </div>
          <div class="mt-1" v-else>
            <button type="submit" class="button" v-if="userRole ==1"><span>Update supplier</span></button>
          </div>
        </div>
      </div>
    </form>
    <template v-if="supplier">
      <InvoicesWithDetails 
        :invoiceFor="supplier" 
        invoiceForTag="supplier"
        :invoices="supplier_invoices"
        @handle-new-invoice="updateInvoiceList"
      />
    </template>
  </div>
</template>

<script>
import SupplierFields from '@/components/SupplierFields.vue'
import InvoicesWithDetails from '@/components/InvoicesWithDetails.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'SupplierEdit',
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data () {
    return {
      supplier: null,
      errors: null,
      supplier_invoices:[]
    }
  },
  components: {
    SupplierFields,
    Errors,
    InvoicesWithDetails
  },
  created () {
    this.getSupplier()
  },
  watch: {
    '$route': 'getSupplier'
  },
  methods: {
    getSupplier () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'suppliers/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.supplier = response.data
        this.supplier_invoices = response.data.payment_invoices
      })
    },
    updateSupplier () {
              console.log(this.supplier)

      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'suppliers/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(this.supplier),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        console.log(response)
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    updateInvoiceList(invoice_object) {
      this.supplier_invoices = invoice_object
    }
  }
}
</script>
